import {MdLogout} from "react-icons/md";
import { BsPersonFillCheck,BsCashCoin } from "react-icons/bs";
import { HiRefresh } from "react-icons/hi";

function LogoutBox({setFlap,flap,setLoginUser,setShowAlert, setAlertMessage,user,refreshQuota}){
    const handleClick = ()=>{
        setLoginUser('');
        setFlap(!flap);
        setAlertMessage("Logged out successfully");
        setShowAlert(true);
        window.location.reload();

    }

    return (
    <div className="flap-container" style={{'width':'100%',backgroundColor:"whitesmoke",boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)'}}>
        <div style={{'width':'90%',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
        <div  className="col-auto">
            <BsCashCoin style={{fontSize:'30px',marginRight:'5px',color:'#3e6585'}} />
            <label  className="col-form-label" style={{color:'#3e6585',fontWeight:'bold'}}>Quota : {user.used_quota} / {user.allocated_quota}</label>
            <button onClick={refreshQuota} className="refresh_button"><HiRefresh style={{fontSize:'25px',color:'whitesmoke'}} /></button>
            
        </div>
        <div className="col-auto">
            <BsPersonFillCheck style={{fontSize:'30px',marginRight:'5px',color:'#3e6585'}} />
            <label  className="col-form-label" style={{color:'#3e6585'}}>Welcome, {user.dashboard_name}!</label>
            
        </div>
        
        <div className="col-auto">
            <button onClick={handleClick} className="karma_button" style={{marginLeft:'10px'}}><MdLogout style={{fontSize:'20px',marginRight:'5px'}}/>Logout</button>
        </div>

        </div>
        
    
    
   
</div>)
}

export default LogoutBox;